function getOpt (pmData) {

  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  //	for(let i=1;i<=12;i++){
  //		xData.push(i);
  //		let ran=Math.ceil(Math.random()*200+20);
  //		y1Data.push(ran);
  //		y2Data.push(ran+10)
  //	}
 
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: 'axis'
    },
    legend: {
      show: false,
      icon: 'rect',
      itemWidth: 14,
      itemHeight: 4,
      //    itemGap: 13,
      //    data: legend,
      left: '22%',
      top: '8%',
      textStyle: {
        fontSize: 14,
        color: 'rgba(255,255,255,0.6)',
        padding: [2, 0, 0, 0]
      }
    },
    grid: {
      top: '25%',
      left: '5%',
      right: '6%',
      bottom: '10%',
      containLabel: true,
    },
    xAxis: [{
      type: 'category',
      //    boundaryGap: false,
      axisLine: {
        show: true,
        lineStyle: {
          //        color: '#3b8d77',
          color: 'grey',
          width: 0.1
        },
      },
      boundaryGap: true,
      axisLabel: {
        //    	rotate: 20,
        //    	lineHeight: -46,
        //    	align: 'center',
        //    	verticalAlign:'bottom',
        //    	interval: 0,
        textStyle: {
          //        color: 'rgb(55, 212, 223)',
          color: "#b1b6b7",
          fontSize: 12,
          margin: 15,
        },
      },
      axisTick: {
        show: false,
      },
      data: xData,
    }],
    yAxis: [{
      name: '单位：μg/m³',
      nameTextStyle: {
        fontSize: 14,
        color: "#A6CAFF",
        padding: [0, 0, 0, 20]
      },
      type: 'value',
      //    interval: 18,
      min: 0,
      //    interval:100,
      minInterval: 50,
      //    boundaryGap : [ 0, 0.5], 
      //      max:140,
      //    splitNumber: 6,
      splitLine: {
        show: false,
        lineStyle: {
          //        color: '#3b8d77'
          color: 'grey',
          width: 0.3
        }
      },
      axisLine: {
        show: true,
        lineStyle: {
          //        color: '#3b8d77'
          color: 'grey',
          width: 1
        }
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          color: '#b1b6b7',
          fontSize: 12,
        },
      },
      axisTick: {
        show: false,
      },
    }],
    series: [{
      name: "PM10",
      type: 'line',
      smooth: true,
      symbolSize: 0,
      lineStyle: {
        normal: {
          width: 2,
          color: "rgba(103, 182, 255,1)"
        }
      },
      areaStyle: {
        show: false,
        //      color: "#fff"
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(103, 182, 255,1)'
          },
          {
            offset: .5,
            color: 'rgba(103, 182, 255,.1)'
          },
          {
            offset: 1,
            color: 'rgba(103, 182, 255,.1)'
          }
          ], false)
        }
      },
      itemStyle: {
        normal: {
          color: "rgba(103, 182, 255,1)",

        }
      },
      data: y1Data
    }]
  };
}

export default getOpt